import _toConsumableArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import { useState, useRef, useEffect } from "react";
import { useTranslation } from "@i18n";
import { scrollToElement } from "@/utils/GlobalJavascriptFunction";
import CarDetailsSection from "./components/carDetailsSection/CarDetailsSection";
import FAQ from "@/pages/home/homePageComponents/components/FAQ/FAQ";
import stl from "./NewPostView.module.css";
import AdNumber from "./components/leftColumn/components/adNumber/AdNumber";
import { CDN_LINK } from "@globalConfig";
import { oldImageViewEvent } from "@/utils/dataLayerEvents";
import LazyLoadComponent from "@hooks/LazyLoadComponent";
import loadable from "@loadable/component";
import { useSearchParams } from "react-router-dom";
import { trackEvents } from "@/common/events/events";
import LessThanMarket from "./components/leftColumn/components/lessThanMarket/LessThanMarket";
import LabelsCA from "./components/leftColumn/components/labelsCA/LabelsCA";
import ProgressiveImage from "@componentsShared/ProgressiveImage";
import { thumbUrl } from "@/utils/imagesHelpers";
import useIsMobile from "@hooks/useIsMobile";
import PaymentTabBox from "./components/leftColumn/components/paymentTabBox/PaymentTabBox";
import NewPostBigSlider from "./components/newPostBigSlider/NewPostBigSlider";
import SimilarPosts from "@/pages/post/PostViewComponents/components/SimilarPosts/SimilarPosts";
import { getAndClearTrackingReferralParams } from "@hooks/useHashToLocalStoreEvent";
import { useChatBot } from "@hooks/useChatBot";
import useHelpers from "@hooks/useHelpers";
import WithScrollToTop from "@/common/HOCs/WithScrollToTop/WithScrollToTop";
import BreadCrumb from "@componentsShared/BreadCrumb";
import { useRecentlyViewedContext } from "@/_MiniApps/RecentlyViewedContext/RecentlyViewedContext";
var fallback = {
  fallback: "..."
};
export var CarReportSection = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "components-carReportSection-CarReportSection";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "components-carReportSection-CarReportSection" */"./components/carReportSection/CarReportSection");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("./components/carReportSection/CarReportSection");
    }
    return eval('require.resolve')("./components/carReportSection/CarReportSection");
  }
}, fallback);
export var AdSection = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "components-adSection-AdSection";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "components-adSection-AdSection" */"./components/adSection/AdSection");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("./components/adSection/AdSection");
    }
    return eval('require.resolve')("./components/adSection/AdSection");
  }
}, fallback);
var LimitedAvaInfoBox = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "pages-post-PostViewComponents-components-leftColumn-components-limitedAvailability-limitedAvailabilityComponent-components-LimitedAvaInfoBox-LimitedAvaInfoBox";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "pages-post-PostViewComponents-components-leftColumn-components-limitedAvailability-limitedAvailabilityComponent-components-LimitedAvaInfoBox-LimitedAvaInfoBox" */"@/pages/post/PostViewComponents/components/leftColumn/components/limitedAvailability/limitedAvailabilityComponent/components/LimitedAvaInfoBox/LimitedAvaInfoBox");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("@/pages/post/PostViewComponents/components/leftColumn/components/limitedAvailability/limitedAvailabilityComponent/components/LimitedAvaInfoBox/LimitedAvaInfoBox");
    }
    return eval('require.resolve')("@/pages/post/PostViewComponents/components/leftColumn/components/limitedAvailability/limitedAvailabilityComponent/components/LimitedAvaInfoBox/LimitedAvaInfoBox");
  }
}, fallback);
var ShareNP = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "components-leftColumn-components-shareNP-ShareNP";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "components-leftColumn-components-shareNP-ShareNP" */"./components/leftColumn/components/shareNP/ShareNP");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("./components/leftColumn/components/shareNP/ShareNP");
    }
    return eval('require.resolve')("./components/leftColumn/components/shareNP/ShareNP");
  }
}, fallback);
var InspectionView = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "pages-post-PostViewComponents-components-InspectionView-InspectionView";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "pages-post-PostViewComponents-components-InspectionView-InspectionView" */"@/pages/post/PostViewComponents/components/InspectionView/InspectionView");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("@/pages/post/PostViewComponents/components/InspectionView/InspectionView");
    }
    return eval('require.resolve')("@/pages/post/PostViewComponents/components/InspectionView/InspectionView");
  }
}, fallback);
var CashPayment = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "components-leftColumn-components-cashPayment-CashPayment";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "components-leftColumn-components-cashPayment-CashPayment" */"./components/leftColumn/components/cashPayment/CashPayment");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("./components/leftColumn/components/cashPayment/CashPayment");
    }
    return eval('require.resolve')("./components/leftColumn/components/cashPayment/CashPayment");
  }
}, fallback);
var DmanProgram = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "components-dmanProgram-DmanProgram";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "components-dmanProgram-DmanProgram" */"./components/dmanProgram/DmanProgram");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("./components/dmanProgram/DmanProgram");
    }
    return eval('require.resolve')("./components/dmanProgram/DmanProgram");
  }
}, fallback);
var TfaseelAndRportHeader = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "components-tfaseelAndRportHeader-TfaseelAndRportHeader";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "components-tfaseelAndRportHeader-TfaseelAndRportHeader" */"./components/tfaseelAndRportHeader/TfaseelAndRportHeader");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("./components/tfaseelAndRportHeader/TfaseelAndRportHeader");
    }
    return eval('require.resolve')("./components/tfaseelAndRportHeader/TfaseelAndRportHeader");
  }
}, fallback);
var MobilePayment = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "components-mobilePayment-MobilePayment";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "components-mobilePayment-MobilePayment" */"./components/mobilePayment/MobilePayment");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("./components/mobilePayment/MobilePayment");
    }
    return eval('require.resolve')("./components/mobilePayment/MobilePayment");
  }
}, fallback);
var LimitedAvailability = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "components-leftColumn-components-limitedAvailability-LimitedAvailability";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "components-leftColumn-components-limitedAvailability-LimitedAvailability" */"./components/leftColumn/components/limitedAvailability/LimitedAvailability");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("./components/leftColumn/components/limitedAvailability/LimitedAvailability");
    }
    return eval('require.resolve')("./components/leftColumn/components/limitedAvailability/LimitedAvailability");
  }
}, fallback);
var PostViewCampaign = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "components-PostViewCampaign-PostViewCampaign";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "components-PostViewCampaign-PostViewCampaign" */"./components/PostViewCampaign/PostViewCampaign");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("./components/PostViewCampaign/PostViewCampaign");
    }
    return eval('require.resolve')("./components/PostViewCampaign/PostViewCampaign");
  }
}, fallback);
var Story = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "componentsShared-Story-Story";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "componentsShared-Story-Story" */"@componentsShared/Story/Story");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("@componentsShared/Story/Story");
    }
    return eval('require.resolve')("@componentsShared/Story/Story");
  }
}, fallback);
var WarrantyAndDealerSection = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "components-WarrantyAndDealerSection-WarrantyAndDealerSection";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "components-WarrantyAndDealerSection-WarrantyAndDealerSection" */"./components/WarrantyAndDealerSection/WarrantyAndDealerSection");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("./components/WarrantyAndDealerSection/WarrantyAndDealerSection");
    }
    return eval('require.resolve')("./components/WarrantyAndDealerSection/WarrantyAndDealerSection");
  }
}, fallback);
var LeftColumn = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "components-leftColumn-LeftColumn";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "components-leftColumn-LeftColumn" */"./components/leftColumn/LeftColumn");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("./components/leftColumn/LeftColumn");
    }
    return eval('require.resolve')("./components/leftColumn/LeftColumn");
  }
}, fallback);
var AddToFavoriteButton = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "common-HOCs-AddToFavorite-AddToFavoriteButton";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "common-HOCs-AddToFavorite-AddToFavoriteButton" */"@/common/HOCs/AddToFavorite/AddToFavoriteButton");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("@/common/HOCs/AddToFavorite/AddToFavoriteButton");
    }
    return eval('require.resolve')("@/common/HOCs/AddToFavorite/AddToFavoriteButton");
  }
}, fallback);
var NewPostView = function NewPostView(props) {
  var _details$details_card, _details$details_card2, _props$postData, _gallery$images2, _gallery$images2$, _props$postData3, _props$postData3$deta, _props$postData4, _props$postData4$vide, _props$postData5, _props$postData6, _props$postData6$gall, _props$postData7, _props$postData7$gall, _gallery$images3, _props$postData$price, _props$postData$price2, _details$details_card7, _details$details_card8, _props$postData9, _props$postData0, _details$details_card9, _props$postData1, _props$postData10, _props$postData11, _props$postData12, _props$postData13, _props$postData14, _props$postData15, _props$postData15$sto, _props$postData15$sto2, _details$details_card0;
  useChatBot();
  var isMobile = useIsMobile();
  var _useTranslation = useTranslation(["web_post_view", "web_common"]),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl,
    createUrlAbsolute = _useHelpers.createUrlAbsolute;
  var _useSearchParams = useSearchParams(),
    _useSearchParams2 = _slicedToArray(_useSearchParams, 1),
    searchParams = _useSearchParams2[0];
  // Props Data
  var _ref = props.postData || {},
    details = _ref.details,
    gallery = _ref.gallery,
    quality = _ref.quality,
    options = _ref.options,
    inspection = _ref.inspection,
    story = _ref.story,
    faqs = _ref.faqs,
    footer = _ref.footer;
  var hasCampaign = details === null || details === void 0 ? void 0 : details.campaigns;
  var hasDaman = (details === null || details === void 0 ? void 0 : (_details$details_card = details.details_card) === null || _details$details_card === void 0 ? void 0 : (_details$details_card2 = _details$details_card.is_new) === null || _details$details_card2 === void 0 ? void 0 : _details$details_card2.id) === 0;
  var g4_data = props === null || props === void 0 ? void 0 : (_props$postData = props.postData) === null || _props$postData === void 0 ? void 0 : _props$postData.g4Data;
  var isUsed = (g4_data === null || g4_data === void 0 ? void 0 : g4_data.post_condition) === "used";

  //   refs
  var carInfoRef = useRef();
  var carReportRef = useRef();
  // end refs

  //   state
  var _useState = useState(false),
    has360Flag = _useState[0],
    setHas360Flag = _useState[1];
  var _useState2 = useState(0),
    activeReport = _useState2[0],
    setActiveReport = _useState2[1];
  var _useState3 = useState(0),
    activeInspectionIndex = _useState3[0],
    setActiveInspectionIndex = _useState3[1];
  var _useState4 = useState(false),
    inspectReport = _useState4[0],
    setInspectReport = _useState4[1];
  var _useState5 = useState("Itab0"),
    activeInpectionTab = _useState5[0],
    setActiveInpectionTab = _useState5[1];
  var _useState6 = useState(false),
    showStory = _useState6[0],
    setShowStory = _useState6[1];
  var _useState7 = useState("cash"),
    PaymentTypeFlag = _useState7[0],
    _setPaymentTypeFlag = _useState7[1];
  var _useState8 = useState(false),
    openBigGall = _useState8[0],
    setOpenBigGall = _useState8[1];

  // End state

  var _useRecentlyViewedCon = useRecentlyViewedContext(),
    addCarIDtoViewedList = _useRecentlyViewedCon.addCarIDtoViewedList,
    renderRecentlyViewedCars = _useRecentlyViewedCon.renderRecentlyViewedCars;
  useEffect(function () {
    addCarIDtoViewedList(details === null || details === void 0 ? void 0 : details.id);
  }, [details === null || details === void 0 ? void 0 : details.id]);
  useEffect(function () {
    var _gallery$images, _gallery$images$;
    if (!(gallery !== null && gallery !== void 0 && (_gallery$images = gallery.images) !== null && _gallery$images !== void 0 && (_gallery$images$ = _gallery$images[0]) !== null && _gallery$images$ !== void 0 && _gallery$images$.img_url)) {
      return;
    }

    // Small delay to ensure hash processing is complete
    var timeoutId = setTimeout(function () {
      var hashObject = getAndClearTrackingReferralParams();
      var bigGallView = hashObject === null || hashObject === void 0 ? void 0 : hashObject.bigGallView;
      if (bigGallView && parseInt(bigGallView)) {
        setOpenBigGall(true);
      }
      if (g4_data) {
        trackEvents("view_post", _objectSpread(_objectSpread(_objectSpread({}, g4_data), hashObject), {}, {
          is_rec: !!hashObject.is_rec,
          post_trim: g4_data.post_ext,
          post_url: window.location.href,
          inventory_type_string: g4_data === null || g4_data === void 0 ? void 0 : g4_data.inventory_type_string,
          section_type: hashObject.section_type
        }));
      }
    }, 50);
    return function () {
      return clearTimeout(timeoutId);
    };
  }, [gallery === null || gallery === void 0 ? void 0 : (_gallery$images2 = gallery.images) === null || _gallery$images2 === void 0 ? void 0 : (_gallery$images2$ = _gallery$images2[0]) === null || _gallery$images2$ === void 0 ? void 0 : _gallery$images2$.img_url]);

  //   functions
  useEffect(function () {
    var _document$querySelect, _document$querySelect2, _document$querySelect3, _document$getElementB;
    var flippingFactor = ((_document$querySelect = document.querySelector("body")) === null || _document$querySelect === void 0 ? void 0 : (_document$querySelect2 = _document$querySelect.attributes) === null || _document$querySelect2 === void 0 ? void 0 : (_document$querySelect3 = _document$querySelect2.dir) === null || _document$querySelect3 === void 0 ? void 0 : _document$querySelect3.value) !== "ltr" ? -1 : 1;
    activeInspectionIndex != activeInpectionTab.split("Itab")[1] && setActiveInspectionIndex(activeInpectionTab.split("Itab")[1]);
    document.getElementById("scrollMeNow") != null && document.getElementById("scrollMeNow").scrollTo({
      top: ((_document$getElementB = document.getElementById(activeInpectionTab)) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.offsetTop) - 140
    });
    if (document.getElementById("scrollVerUlMN") != null && window.innerWidth <= 1024) {
      var _document$getElementB2;
      (_document$getElementB2 = document.getElementById("scrollVerUlMN")) === null || _document$getElementB2 === void 0 ? void 0 : _document$getElementB2.scrollTo({
        left: flippingFactor * (parseInt(activeInpectionTab.split("Itab")[1]) - 1) * 55,
        behavior: "smooth"
      });
    }
  }, [activeInpectionTab]);
  var setActiveInspectionIndexFunction = function setActiveInspectionIndexFunction(val) {
    setActiveInspectionIndex(undefined);
    setActiveInspectionIndex(val);
    setActiveInpectionTab("Itab" + val);
  };
  function getBreadcrumb() {
    var _props$postData2, _details$details_card3, _details$details_card4, _details$details_card5, _details$details_card6;
    var _ref2 = (props === null || props === void 0 ? void 0 : (_props$postData2 = props.postData) === null || _props$postData2 === void 0 ? void 0 : _props$postData2.analytics) || {},
      brand = _ref2.brand,
      model = _ref2.model,
      year = _ref2.year;
    var brandSlug = brand === null || brand === void 0 ? void 0 : brand.slugify();
    var modelSlug = model === null || model === void 0 ? void 0 : model.slugify();
    var breadcrumbLinks = [{
      title: t("سيارات و مركبات", {
        ns: "web_post_view"
      }),
      link: createUrl("/autos"),
      event: function event() {
        return trackEvents("browse_cars", {
          referral_location: "Post View",
          category_path: "autos>all"
        });
      }
    }, {
      title: details === null || details === void 0 ? void 0 : (_details$details_card3 = details.details_card) === null || _details$details_card3 === void 0 ? void 0 : (_details$details_card4 = _details$details_card3.make) === null || _details$details_card4 === void 0 ? void 0 : _details$details_card4.name,
      link: createUrl("/autos/".concat(brandSlug)),
      event: function event() {
        return trackEvents("browse_cars", {
          referral_location: "Post View",
          browse_variant: "make",
          variant_value: brandSlug,
          category_path: "autos>".concat(brandSlug)
        });
      }
    }, {
      title: details === null || details === void 0 ? void 0 : (_details$details_card5 = details.details_card) === null || _details$details_card5 === void 0 ? void 0 : (_details$details_card6 = _details$details_card5.model) === null || _details$details_card6 === void 0 ? void 0 : _details$details_card6.name,
      link: createUrl("/autos/".concat(brandSlug, "/").concat(modelSlug)),
      event: function event() {
        return trackEvents("browse_cars", {
          referral_location: "Post View",
          browse_variant: "model",
          variant_value: modelSlug,
          category_path: "autos>".concat(brandSlug, ">").concat(modelSlug)
        });
      }
    }, {
      title: "".concat(year),
      link: createUrl("/autos/".concat(brandSlug, "/").concat(modelSlug, "/").concat(year)),
      event: function event() {
        return trackEvents("browse_cars", {
          referral_location: "Post View",
          browse_variant: "year",
          variant_value: year,
          category_path: "autos>".concat(brandSlug, ">").concat(modelSlug, ">").concat(year)
        });
      }
    }];
    return /*#__PURE__*/React.createElement(BreadCrumb, {
      className: "mt-1",
      links: breadcrumbLinks
    });
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(React.Fragment, null, inspectReport && /*#__PURE__*/React.createElement(InspectionView, {
    scrollViewId: function scrollViewId(val) {
      setActiveInspectionIndex(val.split("Itab")[1]);
    },
    activeInpectionTab: activeInpectionTab,
    closeReport: function closeReport() {
      setInspectReport(false);
    },
    activeInspectionIndex: activeInspectionIndex,
    setNewActiveIndex: function setNewActiveIndex(val) {
      setActiveInspectionIndexFunction(val);
    },
    notes: inspection === null || inspection === void 0 ? void 0 : inspection.maintained_notes,
    date: inspection === null || inspection === void 0 ? void 0 : inspection.report_date,
    data: inspection && inspection.car_report && inspection.external_body ? [].concat(_toConsumableArray(inspection.car_report), [inspection.external_body]) : [],
    g4_data: g4_data
  }), !isMobile && getBreadcrumb(), /*#__PURE__*/React.createElement("div", {
    className: stl.postViewContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: [stl.container, "container", stl.postMainColumns].join(" ")
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: [stl.sliderHeighCls, stl.noRad].join(" ")
  }, props === null || props === void 0 ? void 0 : (_props$postData3 = props.postData) === null || _props$postData3 === void 0 ? void 0 : (_props$postData3$deta = _props$postData3.details_section) === null || _props$postData3$deta === void 0 ? void 0 : _props$postData3$deta.title, /*#__PURE__*/React.createElement(NewPostBigSlider, {
    openInFull: openBigGall,
    g4_data: g4_data || {},
    hasCampaign: hasCampaign,
    isTrackingView: props.isTrackingView,
    postData: props.postData,
    isLimited: details === null || details === void 0 ? void 0 : details.limited_quantity,
    video: (props === null || props === void 0 ? void 0 : (_props$postData4 = props.postData) === null || _props$postData4 === void 0 ? void 0 : (_props$postData4$vide = _props$postData4.video) === null || _props$postData4$vide === void 0 ? void 0 : _props$postData4$vide.video_link) && (props === null || props === void 0 ? void 0 : (_props$postData5 = props.postData) === null || _props$postData5 === void 0 ? void 0 : _props$postData5.video),
    title: details === null || details === void 0 ? void 0 : details.h1,
    tags: details === null || details === void 0 ? void 0 : details.tags,
    id360: props === null || props === void 0 ? void 0 : (_props$postData6 = props.postData) === null || _props$postData6 === void 0 ? void 0 : (_props$postData6$gall = _props$postData6.gallery) === null || _props$postData6$gall === void 0 ? void 0 : _props$postData6$gall.spin_code,
    showCamera360: props === null || props === void 0 ? void 0 : (_props$postData7 = props.postData) === null || _props$postData7 === void 0 ? void 0 : (_props$postData7$gall = _props$postData7.gallery) === null || _props$postData7$gall === void 0 ? void 0 : _props$postData7$gall.has_spin
  }, (gallery === null || gallery === void 0 ? void 0 : gallery.images) && (gallery === null || gallery === void 0 ? void 0 : (_gallery$images3 = gallery.images) === null || _gallery$images3 === void 0 ? void 0 : _gallery$images3.map(function (sliderItem, i) {
    var _props$postData8, _props$postData8$deta;
    return /*#__PURE__*/React.createElement(ProgressiveImage, {
      key: i,
      img_big_url: sliderItem.img_big_url,
      progressiveSmallImage: i === 0 && thumbUrl(sliderItem === null || sliderItem === void 0 ? void 0 : sliderItem.img_url, "online-v1", isMobile ? "0x99" : "0x300"),
      src: thumbUrl(sliderItem === null || sliderItem === void 0 ? void 0 : sliderItem.img_url, "online-v1", isMobile ? "0x426" : "0x683"),
      "data-src": thumbUrl(sliderItem === null || sliderItem === void 0 ? void 0 : sliderItem.img_url, "online-v1", isMobile ? "0x426" : "0x683"),
      "data-img_thumb_url": sliderItem.img_thumb_url,
      "data-mrk": sliderItem.type === "campaign",
      "data-camera": i === 0 && has360Flag,
      "data-video": sliderItem.type === "video" || sliderItem.type === "youtube" ? sliderItem.video_link : undefined,
      alt: props === null || props === void 0 ? void 0 : (_props$postData8 = props.postData) === null || _props$postData8 === void 0 ? void 0 : (_props$postData8$deta = _props$postData8.details) === null || _props$postData8$deta === void 0 ? void 0 : _props$postData8$deta.h1,
      onClick: function onClick() {
        return oldImageViewEvent(sliderItem.type === "video" ? "Video View" : "Image View");
      }
    });
  })))), hasCampaign && /*#__PURE__*/React.createElement(PostViewCampaign, {
    newCampaignData: details === null || details === void 0 ? void 0 : details.campaigns,
    campaignText: props.campaignText
  }), isMobile && /*#__PURE__*/React.createElement("div", {
    className: "m-show"
  }, getBreadcrumb(), isMobile && /*#__PURE__*/React.createElement("h1", {
    className: stl.carNameMobile
  }, details === null || details === void 0 ? void 0 : details.h1), !props.isTrackingView && (details === null || details === void 0 ? void 0 : details.low_mileage_text) && /*#__PURE__*/React.createElement(LessThanMarket, {
    lowMileage: details === null || details === void 0 ? void 0 : details.low_mileage_text
  }), !props.isTrackingView && /*#__PURE__*/React.createElement(LabelsCA, {
    tags: details === null || details === void 0 ? void 0 : details.tags
  }), !!(details !== null && details !== void 0 && details.is_preowned) && /*#__PURE__*/React.createElement("p", {
    className: stl.preowned
  }, /*#__PURE__*/React.createElement("img", {
    width: "16px",
    height: "16px",
    src: CDN_LINK + "/assets/images/gray-info-icon.svg" // Ensure this path is correct
    ,
    alt: "info"
  }), /*#__PURE__*/React.createElement("span", null, t("هذه سيارة جديدة تم إصدار لوحاتها مسبقا", {
    ns: "web_post_view"
  }))), props.isTrackingView && /*#__PURE__*/React.createElement("div", {
    className: stl.trackingPrice
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", null, t("سعر الكاش", {
    ns: "web_post_view"
  })), /*#__PURE__*/React.createElement("span", {
    style: {
      color: (footer === null || footer === void 0 ? void 0 : footer.remaining_price) <= 0 ? "" : "#00B64E"
    }
  }, footer !== null && footer !== void 0 && footer.total_price ? footer === null || footer === void 0 ? void 0 : footer.total_price : (_props$postData$price = props.postData.price) === null || _props$postData$price === void 0 ? void 0 : (_props$postData$price2 = _props$postData$price.vat_price) === null || _props$postData$price2 === void 0 ? void 0 : _props$postData$price2.text, /*#__PURE__*/React.createElement("span", null, t("ريال", {
    ns: "web_post_view"
  })))), searchParams.get("isCancelled") === "true" ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    className: stl.isCancelled
  }, " ", t("تم إلغاء الطلب", {
    ns: "web_post_view"
  }))) : (footer === null || footer === void 0 ? void 0 : footer.remaining_price) <= 0 ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    className: stl.fullypaid
  }, " ", t("مدفوع كاملاً", {
    ns: "web_post_view"
  }))) : (footer === null || footer === void 0 ? void 0 : footer.remaining_price) && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", null, t("المبلغ المتبقي", {
    ns: "web_post_view"
  })), /*#__PURE__*/React.createElement("span", null, footer === null || footer === void 0 ? void 0 : footer.remaining_price, /*#__PURE__*/React.createElement("span", null, t("ريال", {
    ns: "web_post_view"
  }))))), !props.isTrackingView && /*#__PURE__*/React.createElement(React.Fragment, null, details !== null && details !== void 0 && details.limited_quantity && details !== null && details !== void 0 && (_details$details_card7 = details.details_card) !== null && _details$details_card7 !== void 0 && (_details$details_card8 = _details$details_card7.is_new) !== null && _details$details_card8 !== void 0 && _details$details_card8.id ? /*#__PURE__*/React.createElement(LimitedAvailability, {
    priceSection: props === null || props === void 0 ? void 0 : (_props$postData9 = props.postData) === null || _props$postData9 === void 0 ? void 0 : _props$postData9.price,
    ShowStory: function ShowStory() {
      return setShowStory(true);
    },
    g4_data: g4_data,
    post: details
  }) : details !== null && details !== void 0 && details.have_finance ? /*#__PURE__*/React.createElement(React.Fragment, null, isMobile && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PaymentTabBox, {
    isUsed: isUsed,
    hidePaymentBtn: true,
    post: details,
    priceSection: props === null || props === void 0 ? void 0 : (_props$postData0 = props.postData) === null || _props$postData0 === void 0 ? void 0 : _props$postData0.price,
    postId: details === null || details === void 0 ? void 0 : details.id,
    postTitle: details === null || details === void 0 ? void 0 : details.title,
    ShowStory: function ShowStory() {
      return setShowStory(true);
    },
    setPaymentTypeFlag: function setPaymentTypeFlag(val) {
      return _setPaymentTypeFlag(val);
    },
    titleForPaymentBox: PaymentTypeFlag !== "cash" ? story === null || story === void 0 ? void 0 : story.finance_story.title : story === null || story === void 0 ? void 0 : story.cash_story.title,
    arboun: footer === null || footer === void 0 ? void 0 : footer.arboun,
    reserved: footer === null || footer === void 0 ? void 0 : footer.reserved,
    footer: footer,
    g4_data: g4_data,
    car_condition: !(details !== null && details !== void 0 && (_details$details_card9 = details.details_card) !== null && _details$details_card9 !== void 0 && _details$details_card9.is_new.id) ? "used" : details !== null && details !== void 0 && details.is_chinese ? "chinese" : "new",
    gallery: gallery,
    details: details
  }))) :
  /*#__PURE__*/
  //)}/>
  React.createElement(CashPayment, {
    priceSection: props === null || props === void 0 ? void 0 : (_props$postData1 = props.postData) === null || _props$postData1 === void 0 ? void 0 : _props$postData1.price,
    postId: details === null || details === void 0 ? void 0 : details.id,
    postTitle: details === null || details === void 0 ? void 0 : details.title,
    hidePaymentBtn: true,
    ShowStory: function ShowStory() {
      return setShowStory(true);
    },
    postData: props === null || props === void 0 ? void 0 : props.postData,
    g4_data: g4_data,
    details: details,
    gallery: props === null || props === void 0 ? void 0 : (_props$postData10 = props.postData) === null || _props$postData10 === void 0 ? void 0 : _props$postData10.gallery,
    footer: footer
  })), !props.isTrackingView && /*#__PURE__*/React.createElement(LazyLoadComponent, {
    loadComponent: function loadComponent() {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AddToFavoriteButton, {
        isFromPostView: true,
        postId: details === null || details === void 0 ? void 0 : details.id,
        className: [stl.FavoriteButtonMobile, "m-show"].join(" "),
        g4_data: g4_data
      }), /*#__PURE__*/React.createElement(ShareNP, {
        postData: props.postData,
        title: details === null || details === void 0 ? void 0 : details.title,
        postDynamicLink: createUrlAbsolute("/cardetail/".concat(details === null || details === void 0 ? void 0 : details.id)),
        mobileShare: true
      }));
    }
  })), isMobile && hasDaman && /*#__PURE__*/React.createElement(LazyLoadComponent, {
    loadComponent: function loadComponent() {
      return /*#__PURE__*/React.createElement(DmanProgram, {
        qualitySection: quality,
        g4_data: g4_data
      });
    }
  }), !isMobile && hasDaman && /*#__PURE__*/React.createElement(DmanProgram, {
    qualitySection: quality,
    g4_data: g4_data
  }), isUsed && /*#__PURE__*/React.createElement(TfaseelAndRportHeader, {
    isInspectionAvailable: true,
    activeReport: activeReport,
    setActive: function setActive(val) {
      setActiveReport(undefined);
      val == 0 && scrollToElement(carInfoRef.current, -100);
      val == 1 && scrollToElement(carReportRef.current, -100);
      var val2 = val;
      setTimeout(function () {
        setActiveReport(val2);
      }, 700);
    }
  }), /*#__PURE__*/React.createElement("div", {
    ref: carInfoRef
  }, /*#__PURE__*/React.createElement(CarDetailsSection, {
    screen_view_referral: props.screen_view_referral,
    sections: options === null || options === void 0 ? void 0 : options.options,
    carDetails: details === null || details === void 0 ? void 0 : details.details_card,
    fuelEco: ((_props$postData11 = props.postData) === null || _props$postData11 === void 0 ? void 0 : _props$postData11.fuel) && props.postData.fuel.length !== 0 && Object.keys((_props$postData12 = props.postData) === null || _props$postData12 === void 0 ? void 0 : _props$postData12.fuel).length != 0 && ((_props$postData13 = props.postData) === null || _props$postData13 === void 0 ? void 0 : _props$postData13.fuel),
    mojazData: details === null || details === void 0 ? void 0 : details.mojaz_report,
    g4_data: (_props$postData14 = props.postData) === null || _props$postData14 === void 0 ? void 0 : _props$postData14.g4Data
  })), /*#__PURE__*/React.createElement("div", {
    ref: carReportRef
  }, /*#__PURE__*/React.createElement(LazyLoadComponent, {
    loadComponent: function loadComponent() {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(WarrantyAndDealerSection, {
        warranty_card: details === null || details === void 0 ? void 0 : details.warranty_card
      }), (details === null || details === void 0 ? void 0 : details.id) && /*#__PURE__*/React.createElement(CarReportSection, {
        postId: details === null || details === void 0 ? void 0 : details.id,
        inspection: inspection,
        clickFunction: function clickFunction(val) {
          setInspectReport(true);
          setActiveInpectionTab(val);
        },
        g4_data: g4_data
      }));
    }
  }))), /*#__PURE__*/React.createElement("div", null, !isMobile && /*#__PURE__*/React.createElement(LeftColumn, {
    isTrackingView: props.isTrackingView,
    isUsed: isUsed,
    setPaymentTypeFlag: function setPaymentTypeFlag(val) {
      return _setPaymentTypeFlag(val);
    },
    titleForPaymentBox: PaymentTypeFlag !== "cash" ? story === null || story === void 0 ? void 0 : story.finance_story.title : story === null || story === void 0 ? void 0 : story.cash_story.title,
    scrollToMayzat: function scrollToMayzat() {
      return scrollToElement(document.getElementById("scrollMeMazeedNew"), -100);
    },
    ShowStory: function ShowStory() {
      return setShowStory(true);
    },
    postData: props.postData,
    mostPopular: options === null || options === void 0 ? void 0 : options.most_popular,
    isCancelled: searchParams.get("isCancelled") === "true",
    g4_data: g4_data
  }))), /*#__PURE__*/React.createElement(SimilarPosts, {
    postId: details === null || details === void 0 ? void 0 : details.id
  }), renderRecentlyViewedCars(stl.recentViewsContainer), isUsed && /*#__PURE__*/React.createElement(LazyLoadComponent, {
    loadComponent: function loadComponent() {
      return /*#__PURE__*/React.createElement(AdSection, null);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: stl.faqContainer
  }, /*#__PURE__*/React.createElement(FAQ, {
    faqs: faqs,
    isHomePage: true
  })), /*#__PURE__*/React.createElement("div", {
    className: "m-show"
  }, /*#__PURE__*/React.createElement(AdNumber, {
    adNumber: details === null || details === void 0 ? void 0 : details.id,
    isTrackingView: props.isTrackingView
  }), (details === null || details === void 0 ? void 0 : details.limited_quantity) && /*#__PURE__*/React.createElement(LimitedAvaInfoBox, null)))), showStory && /*#__PURE__*/React.createElement(Story, {
    showStoryMode: showStory,
    closeStory: function closeStory() {
      return setShowStory(false);
    },
    BGColor: PaymentTypeFlag === "cash" ? "linear-gradient(180deg, rgba(48,75,165,1) 0%, rgba(74,167,221,1) 100%)" : ""
  }, PaymentTypeFlag !== "cash" ? story === null || story === void 0 ? void 0 : story.finance_story.data.map(function (story, idx) {
    return /*#__PURE__*/React.createElement("div", {
      key: "stry" + idx,
      className: "singleStry"
    }, /*#__PURE__*/React.createElement("strong", {
      style: {
        textAlign: "center"
      }
    }, story === null || story === void 0 ? void 0 : story.finance_story.title), /*#__PURE__*/React.createElement("img", {
      src: story.image,
      alt: "story"
    }));
  }) : props === null || props === void 0 ? void 0 : (_props$postData15 = props.postData) === null || _props$postData15 === void 0 ? void 0 : (_props$postData15$sto = _props$postData15.story) === null || _props$postData15$sto === void 0 ? void 0 : (_props$postData15$sto2 = _props$postData15$sto.cash_story) === null || _props$postData15$sto2 === void 0 ? void 0 : _props$postData15$sto2.data.map(function (story, idx) {
    var _props$postData16, _props$postData16$sto, _props$postData16$sto2, _props$postData17, _props$postData17$sto, _props$postData17$sto2;
    return /*#__PURE__*/React.createElement("div", {
      key: "stry" + idx,
      className: "singleStry",
      "data-color": "linear-gradient(180deg, rgba(48,75,165,1) 0%, rgba(74,167,221,1) 100%);"
    }, /*#__PURE__*/React.createElement("strong", {
      style: {
        textAlign: "center"
      }
    }, props === null || props === void 0 ? void 0 : (_props$postData16 = props.postData) === null || _props$postData16 === void 0 ? void 0 : (_props$postData16$sto = _props$postData16.story) === null || _props$postData16$sto === void 0 ? void 0 : (_props$postData16$sto2 = _props$postData16$sto.cash_story) === null || _props$postData16$sto2 === void 0 ? void 0 : _props$postData16$sto2.title), /*#__PURE__*/React.createElement("img", {
      src: props === null || props === void 0 ? void 0 : (_props$postData17 = props.postData) === null || _props$postData17 === void 0 ? void 0 : (_props$postData17$sto = _props$postData17.story) === null || _props$postData17$sto === void 0 ? void 0 : (_props$postData17$sto2 = _props$postData17$sto.cash_story) === null || _props$postData17$sto2 === void 0 ? void 0 : _props$postData17$sto2.img,
      alt: "story"
    }));
  })), !props.isTrackingView && isMobile && /*#__PURE__*/React.createElement("div", {
    className: "m-show"
  }, /*#__PURE__*/React.createElement(MobilePayment, {
    postId: details === null || details === void 0 ? void 0 : details.id,
    arboun: footer === null || footer === void 0 ? void 0 : footer.arboun,
    reserved: footer === null || footer === void 0 ? void 0 : footer.reserved,
    have_finance: details === null || details === void 0 ? void 0 : details.have_finance,
    limited_quantity: details === null || details === void 0 ? void 0 : details.limited_quantity,
    footer: footer,
    isNew: details === null || details === void 0 ? void 0 : (_details$details_card0 = details.details_card) === null || _details$details_card0 === void 0 ? void 0 : _details$details_card0.is_new.id,
    canTestDrive: details === null || details === void 0 ? void 0 : details.can_test_drive,
    testDriveDetails: details === null || details === void 0 ? void 0 : details.test_drive_box,
    postTitle: details === null || details === void 0 ? void 0 : details.title,
    postData: props === null || props === void 0 ? void 0 : props.postData,
    g4_data: g4_data,
    bTop: true,
    closePaymntPopup: function closePaymntPopup(fun) {
      return fun;
    },
    chatBtn: /*#__PURE__*/React.createElement("button", {
      style: {
        display: "none"
      },
      id: "pingpongchat",
      className: [stl.chatBtn].join(" "),
      onClick: function onClick() {
        return window.fcWidget.open();
      }
    }, /*#__PURE__*/React.createElement("i", null), t("الدردشة الفورية", {
      ns: "web_post_view"
    }))
  })), /*#__PURE__*/React.createElement(WithScrollToTop, {
    renderFunction: function renderFunction(_ref3) {
      var onClick = _ref3.onClick,
        isMouseOver = _ref3.isMouseOver;
      return /*#__PURE__*/React.createElement("div", {
        onClick: onClick,
        className: isMouseOver ? 'isMouseOver' : ''
      }, /*#__PURE__*/React.createElement("img", {
        width: "40px",
        src: CDN_LINK + "/assets/images/Backtotop.svg",
        alt: "Back To Top"
      }));
    }
  }));
};
export default NewPostView;